// templateMapper.ts
import type { IThemePageInfo } from '~/types/themePage';
import type { IThemePage } from '~/stores/themePage';

import { getDefaultThumbnail, parseTemplateIdBy, parseTemplateInfoBy } from './templateHandler';
import { ProviderSource } from '~/types/template';

export const mapTemplateInfoV7 = (
  templateSuffix?: string,
  themePages?: IThemePage[],
  isCheckDefault = true,
): IThemePageInfo | undefined => {
  if (!templateSuffix) return;

  if (isCheckDefault) {
    const templateInfoV7Default = mapTemplateInfoV7Default(templateSuffix, themePages);
    if (templateInfoV7Default) {
      return templateInfoV7Default;
    }
  }

  const templateInfo = parseTemplateInfoBy({ templateSuffix });
  if (!templateInfo) return;

  const templateId = parseTemplateIdBy(templateSuffix, ProviderSource.GEMPAGESV7);
  const themePage = themePages?.find((page) => page.id === templateId);
  if (!themePage) return;

  const thumbnail = themePage?.thumbnail || getDefaultThumbnail(templateInfo.providerSource);

  return {
    templateInfo,
    label: themePage.name,
    thumbnail: thumbnail,
    default: false,
    updatedAt: themePage.updatedAt,
    providerSource: ProviderSource.GEMPAGESV7,
    isChildren: !!themePage.parent?.id,
    themePageID: themePage.id,
    status: themePage.status,
    publishedAt: themePage.publishedAt ?? null,
  };
};
export const mapTemplateInfoV7Default = (
  templateSuffix?: string,
  themePages?: IThemePage[],
): IThemePageInfo | undefined => {
  const templateInfo = parseTemplateInfoBy({ templateSuffix });
  if (!templateInfo) return;
  if (templateInfo.providerSource !== ProviderSource.SHOPIFY_ORIGIN) return;

  const themePageByDefault = themePages?.find(
    (page) => !!page.default && templateInfo.type === page.type,
  );
  if (!themePageByDefault) return;

  const label = themePageByDefault?.name;
  const thumbnail = themePageByDefault?.thumbnail ?? getDefaultThumbnail(ProviderSource.GEMPAGESV7);

  return {
    templateInfo,
    label,
    thumbnail,
    default: themePageByDefault.default,
    updatedAt: themePageByDefault.updatedAt,
    providerSource: ProviderSource.SHOPIFY_ORIGIN,
    defaultByProvider: ProviderSource.GEMPAGESV7,
    isChildren: !!themePageByDefault.parent?.id,
    themePageID: themePageByDefault.id,
    status: themePageByDefault.status,
    publishedAt: themePageByDefault.publishedAt ?? null,
  };
};
export const mapTemplateInfoV6 = (
  templateSuffix?: string,
  themePages?: IThemePage[],
): IThemePageInfo | undefined => {
  if (!templateSuffix) return;

  const templateInfo = parseTemplateInfoBy({ templateSuffix });
  if (!templateInfo) return;

  const templateId = parseTemplateIdBy(templateSuffix, ProviderSource.GEMPAGESV6);
  const themePage = themePages?.find((page) => page.id === templateId);
  if (!themePage) return;

  const thumbnail = themePage?.thumbnail || getDefaultThumbnail(templateInfo.providerSource);
  return {
    templateInfo,
    label: themePage.name,
    thumbnail: thumbnail,
    default: !!themePage.default,
    updatedAt: themePage.updatedAt,
    providerSource: ProviderSource.GEMPAGESV6,
    isChildren: false,
    themePageID: themePage.id,
    status: themePage.status,
  };
};
